
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gLcx_o1vlt4PSREEyxS9I_4b7du7XYsxvXKXzNc_Z2xwMeta } from "/codebuild/output/src946993094/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexVHd_45b6W4sPmCZUcqE_45jU_45jB9f_45stj71PPZ7w9A1Zw6EMeta } from "/codebuild/output/src946993094/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchgaeTqrFiO_45whQfH8sEBR1_45U93Td5wYhrAyIu6RY1urcMeta } from "/codebuild/output/src946993094/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexnRLefYqO_3PChsqcktl4Nb1PhaU86MkpfDkoR56t4MkMeta } from "/codebuild/output/src946993094/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_938lh5KAnsyfbsWpLYSKHZcbRuJdmvqPKH_SlWU7waCUgMeta } from "/codebuild/output/src946993094/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexROBGScGQX3PbhXneo4LMtb0n8klTiFlKog_45sPxTbZ8UMeta } from "/codebuild/output/src946993094/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93P_IoY5VFZ2DbYSbshqVt3LoedHuJ50vTW2tDXjB2QtUMeta } from "/codebuild/output/src946993094/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indext9sI0wJa3hVEf0M9Vqif8MAuDMDXWJFZY0bIsItu5woMeta } from "/codebuild/output/src946993094/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93Wm3iFCZudCbTeXr_4520Lny8VlvG1MUMYu7aoR1Q6HBjAMeta } from "/codebuild/output/src946993094/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index1d5fJtSDG1ngdQzS4GDGf5V_45ifX8EhhqDeZWSItQavYMeta } from "/codebuild/output/src946993094/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexAhFziWXMuGFwZOt90Tc4mab1iYTsRJRZURlW73gJJrEMeta } from "/codebuild/output/src946993094/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src946993094/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src946993094/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src946993094/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src946993094/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src946993094/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexROBGScGQX3PbhXneo4LMtb0n8klTiFlKog_45sPxTbZ8UMeta || {},
    component: () => import("/codebuild/output/src946993094/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src946993094/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indext9sI0wJa3hVEf0M9Vqif8MAuDMDXWJFZY0bIsItu5woMeta || {},
    component: () => import("/codebuild/output/src946993094/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src946993094/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index1d5fJtSDG1ngdQzS4GDGf5V_45ifX8EhhqDeZWSItQavYMeta || {},
    component: () => import("/codebuild/output/src946993094/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexAhFziWXMuGFwZOt90Tc4mab1iYTsRJRZURlW73gJJrEMeta || {},
    component: () => import("/codebuild/output/src946993094/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]